import type { ReactNode } from "react";
import "./PreviousNextButton.scss";
import classNames from "classnames";

export type Direction = "previous" | "next";

interface Properties {
  direction: Direction;
  onClick: () => void;
}

export default function PreviousNextButton(props: Properties): ReactNode {
  return (
    <div className="previous-next-button" onClick={props.onClick}>
      <div className={classNames("icon", props.direction)}></div>
    </div>
  );
}
